export default __webpack_public_path__ + "static/media/I-1.3dc95d35.png";